import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  max-width: 31rem;

  height: fit-content;

  display: flex;
  flex-direction: column;

  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%),
    0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);

  padding: 1rem;

  border-radius: 0.4rem;

  > header {
    display: flex;
    align-items: center;
    justify-content: center;

    border-bottom: 0.1rem solid rgba(0, 0, 0, 0.3);
    margin-bottom: 1rem;

    p {
      font-weight: 700;
      font-size: 1.3rem;

      text-transform: uppercase;

      padding: 0.5rem 0;

      color: #333;
    }
  }

  > div:not(:last-child) {
    border-bottom: 0.1rem solid rgba(0, 0, 0, 0.3);
    margin-bottom: 2rem;
    padding-bottom: 2rem;
  }
`;
